import { getRgVersions } from "./index194.js";
import { rgObjectToDto } from "@project-rouge/rg-core";
function rgObjectToDto$1(rgObj) {
	return rgObjectToDto({
		rgObj,
		versions: getRgVersions()
	});
}
export { rgObjectToDto$1 as rgObjectToDto };

//# sourceMappingURL=index195.js.map